import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {UseState}  from "@Common/react/use-state";
import {Watch}     from "@Common/react/watch";

export const BufferForm = ({value, applyChange, disableBuffer, next}) => cs(
    ["buffer", (_, next) => UseState({next})],
    ({buffer}) => fragments(
        (() => {
            const bufferValue = buffer.value == null ? value : buffer.value.value;
            return next({
                value: bufferValue,
                onChange: (v) => {
                    if (v === bufferValue) {
                        return;
                    }
                    buffer.onChange({value: v});
                    applyChange(v);
                },
            });
        })(),
        Watch({
            value: disableBuffer && buffer.value,
            onChanged: (needClearBuffer) => {
                if (needClearBuffer) {
                    buffer.onChange(null);
                }
            },
        }),
    ),
);
